<div class="commande-settings-modal">
	<h2>Liste des articles</h2>
	<div class="commande-settings-modal-content">
		<div *ngIf="data.articles.length !== 0" class="list-articles">
			<mat-selection-list class="list-col" (selectionChange)="changeValue($event)">
				<mat-list-option *ngFor="let article of data.articles" [checkboxPosition]="before" [value]="article">
					{{article.article.designation}}
				</mat-list-option>
			</mat-selection-list>
		</div>
		<div *ngIf="data.articles.length === 0">
			Tous les articles ont été ajouté.
		</div>
		<div mat-dialog-actions class="dialog-buttons">
			<button mat-stroked-button (click)="refuse()">Annuler</button>
			<button mat-flat-button color="primary" [mat-dialog-close]="article" cdkFocusInitial>Ajouter</button>
		</div>
	</div>
</div>